// src/utils/seasonVideo.js
// Sélection automatique de la vidéo de la homepage selon la date.
// Les 4 vidéos existent déjà sur le serveur CMS. On ne fait que choisir la bonne.
//
// Base = même origine que shortVideoFileUrl (asset Statamic).
const BASE = "https://cms.pharmacieplus.ch";

const VIDEOS = {
  printemps: `${BASE}/ParmaciePlus-printemps.mp4`,
  ete: `${BASE}/ParmaciePlus-été.mp4`,
  automne: `${BASE}/ParmaciePlus-automne.mp4`,
  hiver: `${BASE}/ParmaciePlus-hiver.mp4`,
};

// Dates de bascule confirmées par le client (format "MM-DD").
// Ordre décroissant obligatoire.
const SEASONS = [
  { start: "12-01", key: "hiver" },     // 1er décembre
  { start: "09-01", key: "automne" },   // 1er septembre
  { start: "06-01", key: "ete" },       // 1er juin
  { start: "03-01", key: "printemps" }, // 1er mars
];

// Sécurité : jamais de vide. La homepage a toujours une vidéo valide.
const FALLBACK = VIDEOS.printemps;

/**
 * Renvoie l'URL de la vidéo correspondant à la date.
 * @param {Date} date
 * @returns {string} URL complète de la vidéo (toujours valide)
 */
export function getSeasonVideo(date = new Date()) {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const mmdd = `${mm}-${dd}`;

  // Janvier/février (avant le 01-03) => hiver
  const match = SEASONS.find((s) => mmdd >= s.start);
  const key = match ? match.key : "hiver";

  return VIDEOS[key] || FALLBACK;
}